(($) => {
	
	let $body = $('body');
	let $window = $(window);
	let fwpTemplate = $('.facetwp-template');

	if (fwpTemplate.length > 0) fwpTemplate.addClass('columns posts-grid is-multiline');

	const stickyNav = () => {

		if ($window.scrollTop() < 100) {
			$body.removeClass('is-scrolled');
		} else if (!$body.is('.is-scrolled')) {
			$body.addClass('is-scrolled');
		}
		
	}

	$window.on('scroll', () => { window.requestAnimationFrame(stickyNav); });
	stickyNav();

	$(document).ready( () => {
		
		applyInlinePopup();
		applyAjaxPopup();
		
		$body.on( 'av_resize_finished', () => {
			setTimeout( () => {
				applyInlinePopup();
				applyAjaxPopup();
			}, 150);
		});

		$(".hamburger-toggle, .hamburger-overlay").on("click", () => {
			$body.toggleClass("burger-active");
		});
		
	});
	
	const applyInlinePopup = () => {
		
		$('a[href*="inline"], [data-popup]').on('click', (e) => {
			e.preventDefault();
			
			val = $(this).attr('href').split('?');
			
			$.magnificPopup.open({
				items: {
					src: '#'+val[0]
				},
				type: 'inline',
				showCloseBtn: true,
				mainClass: 'avia-popup mfp-zoom-in',
				tLoading: '',
				tClose: ''
			});
			
		});
	}
	
	const applyAjaxPopup = () => {
		$('a[href*="ajax=true"]').magnificPopup({
			type: 'ajax',
			showCloseBtn: true,
			mainClass: 'avia-popup mfp-zoom-in',
			tLoading: '',
			tClose: ''
		});
		
	}
	
})(jQuery);